import { Component, OnInit } from '@angular/core';
import { paymentNsc } from 'app/models/paymentNsc/paymentNsc';
import { HttpTestService } from 'app/services/http.service';
import { consumerDetailsObject } from 'app/models/ConsumerDetailsObject/ConsumerDetailsObject';
import { NavigationExtras, Router } from '@angular/router';
import { loginmodel } from '../../models/login/login.model';
import * as CryptoJS from 'crypto-js';
import { AppComponent} from 'app/app.component';

@Component({
  selector: 'app-payment-nsc',
  templateUrl: './payment-nsc.component.html',
  styleUrls: ['./payment-nsc.component.css']
})
export class PaymentNscComponent implements OnInit {

  public errorMsg : string = "";
  public successMsg : string = "";
  public transId : string;
  public consumerDetails = new consumerDetailsObject();
  public isShow : boolean = true;
  public declaration : string;
  public loginmodel: loginmodel = new loginmodel;
  public serviceOn : boolean = false;
  //public showtransaction : boolean = false;
  public isHideTable : boolean = true;
  public hideSubmit : boolean = true;
  public isHidden : boolean = false;
  public isHideApplicationStatus : boolean = false;
  public isHideExistingLogin : boolean = false;
  public paymentNsc : paymentNsc = new paymentNsc;
  public viewpopupopen : boolean = false;
  public consumerDetailsObject :consumerDetailsObject;
  public trasactionList =[{
    "mobileNumber": String,
    "password":String,
    "transactionId":String,
    "status":String
  }]
  public payNscPostData ={
    "mobileNumber": null,
    "password" : null 
   
  };
   
  transactionIdd: { "mobileNumber": StringConstructor; "password": StringConstructor; "transactionId": StringConstructor; "status": StringConstructor; };
  constructor(public http: HttpTestService,
              private router: Router,
              private appComponent: AppComponent) { }
 
 
  ngOnInit() {
	}
	sendNscReq = function(){
    this.router.navigateByUrl('/transactionDetails',{ skipLocationChange: true });
  }
  back(){
    this.router.navigateByUrl('/nsc',{ skipLocationChange: true });
  }

  valuechange(number){
    if(number.length === 1){
      let mobileNo = "+91"+number;
      this.paymentNsc.mobileNumber = mobileNo;
    }
  }

  focusOutFunction() {
    this.paymentNsc.mobileNumber = "+91" + this.paymentNsc.mobileNumber;
  }

  paymentNscSend = function(){
   // alert("okk")
		var self = this;
    this.hideForm = false;
    self.hideSubmit = true;
    self.errorMsg = "";
    self.isHideApplicationStatus = true;
    
    self.payNscPostData.mobileNumber = self.paymentNsc.mobileNumber;
		self.payNscPostData.password = self.paymentNsc.password;

 	self.http.postPaymentForNsc(self.payNscPostData).subscribe(
			(data:any) => {
        if(data[0].status == 'success' && data[0].powerSupplyType == 'LT'){
          let navigationExtras: NavigationExtras = {queryParams: {"user": JSON.stringify(data)},skipLocationChange: false};
        
        this.appComponent.getBroadCastForPaymentNSC(data[0].blroRegionId,data[0].mouzaZoneId);
        this.router.navigate(["transactionDetails"],{ skipLocationChange: true },  navigationExtras);
        document.getElementById("id1").style.display = "none";
        document.getElementById("id2").style.display = "none";
        document.getElementById("id3").style.display = "none";
       
        self.transactionDetails = data;
        self.trasactionList = data;
        //this.showtransaction = true;
        this.hideSubmit = false;
        }
       
        else if(data[0].powerSupplyType == 'HT'){
          self.isShow = false;
          self.errorMsg = "Please Visit your nearest customer care center";
        }
        
        else  if(data[0].status == 'fail'){
         // alert("okk")
          
          self.errorMsg = "Please use a valid credential.";
          
        }
        // else if(data[0].status == 'success'){
         
        // }
			},
	 		(error) => {
	 			self.errorMsg = error;
	 		},
	 		() => {
        self.serviceOn = false;
        //self.errorMsg = "";
         self.successMsg = "";
      
        // document.getElementById("id1").style.display = "none";
	 		});
  }

  openPopup = function () {
    var self = this;
    self.loginmodel.forgotConsumer = "";
    self.viewpopupopen = true;
    self.errorMsg = "";
    self.successMsg = "";
  }

  closePopup = function () {
    var self = this;
    self.viewpopupopen = false;
    self.loginmodel.forgotConsumer = "";
  }

  forgotPass = function () {
    var self = this;

    self.http.forgotPasswordForNsc(self.loginmodel.emailId)
      .subscribe(
        (data) => {
          self.forgotresponse = data;
        },
        (error) => {
          self.errorMsg = error;
          self.forgotresponse = "";
        },
        () => {
          self.closePopup();
          if (self.forgotresponse) {

            self.successMsg = "Password sent to your registered email id.";
          } else {
            self.errorMsg = "We are unable to process your request.";
          }
        }
      );

  }

}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/payment-nsc/payment-nsc.component.ts